import CONSTANTS from './config/constant'
/**
 * A global plugin to add validations of form fields
 */
const GlobalFromValidationPlugin = {
  install (Vue, options) {
    Vue.prototype.$globalFromValidation = new Vue({
      data () {
        // Any data will go here
        return {}
      },
      computed: {
        // computed props
      },
      methods: {
        // Methods
        /**
        * Helper method validate empty value
        */
        IsEmptyValue (v, semiCustom = '', fullCustom = '') {
          let errorMessage = 'Field is required.'
          if (semiCustom !== '') {
            errorMessage = semiCustom + ' is required'
          }
          if (semiCustom !== '') {
            errorMessage = fullCustom
          }
          return [!!v || errorMessage]
        },
        /**
        * Helper method validate string against
        * only alphabate, space, period
        */
        IsValidAlphaSpacePeriod (v) {
          return /^[a-zA-Z .]+$/.test(v) || 'Invalid input. Only characters (A-Z, a-z), space, period is allowed!'
        },
        /**
         * This is a helper function for checking error message is available
         * If not this function will return a constant value with default error message
         */
        getErrorMessageText (inputString) {
          let errorString = CONSTANTS.SOMETHING_WENT_WRONG
          if (inputString !== undefined && inputString !== '') {
            errorString = inputString
          }
          return errorString
        },
        /**
         * This is a helper function for checking given param is number or not
         * If not this function will return a 0 else the actual param
         */
        paramIsInNumFormat (paramId) {
          const id = Number.parseInt(paramId, 10)
          if (Number.isNaN(id)) {
            return 0
          }
          return id
        },
        IsContainOnlySpace (str) {
          if (!str.replace(/\s/g, '').length) {
            return true
          }
        },
        forceTabActive (routeName) {
          if (routeName === 'Home') {
            document.getElementById('glbTab-1').classList.add('v-tab--active')
            document.getElementById('glbTab-2').classList.remove('v-tab--active')
            document.getElementById('glbTab-3').classList.remove('v-tab--active')
          } if (routeName === 'StateCodeAdoption' || routeName === 'JurisdictionCodeAdoption' || routeName === 'TownshipCodeAdoption' || routeName === 'CountyCodeAdoption') {
            document.getElementById('glbTab-1').classList.add('v-tab--active')
            document.getElementById('glbTab-2').classList.remove('v-tab--active')
            document.getElementById('glbTab-3').classList.remove('v-tab--active')
          } if (routeName === 'ICodeMap') {
            document.getElementById('glbTab-2').classList.add('v-tab--active')
            document.getElementById('glbTab-1').classList.remove('v-tab--active')
            document.getElementById('glbTab-3').classList.remove('v-tab--active')
          } if (routeName === 'GlobalCodes') {
            document.getElementById('glbTab-3').classList.add('v-tab--active')
            document.getElementById('glbTab-1').classList.remove('v-tab--active')
            document.getElementById('glbTab-2').classList.remove('v-tab--active')
          }
          if (routeName === 'WorldCodeAdoption') {
            document.getElementById('glbTab-3').classList.add('v-tab--active')
            document.getElementById('glbTab-1').classList.remove('v-tab--active')
            document.getElementById('glbTab-2').classList.remove('v-tab--active')
          }
        }
      }
    })
  }
}

export default GlobalFromValidationPlugin
